import DashboardLayout from "../pages/Dashboard/Layout/DashboardLayout.vue";
import CategoriaList from '../views/cadastros/categoria/List.vue';
import ItensCategoriaList from '../views/cadastros/itens_categoria/List.vue';
import ModeloCheckList from '../views/cadastros/modelo_checklist/List.vue';
import InspecaoList from '../views/cadastros/inspecao/List.vue';
import RelatorioList from '../views/cadastros/relatorio/List.vue';
import ListProdValidade from '../views/cadastros/relatorio/ListProdValidade.vue';
import ListDocumentos from '../views/cadastros/arquivo_cliente/List.vue';
import FiltrarGrafico from '../views/admin_graficos/Filtrar.vue';
import Dash from '../views/cadastros/dashboard/index.vue';
import Configuracao from '../views/cadastros/configuracao/Form.vue';

let operacionalRoutes = {
    path: "/operacional",
    component: DashboardLayout,
    name: "Operacional",
    icon: "build", //perm_data_setting
    redirect: "/operacional/dashboard",
    children: [
        {
            path: "dashboard",
            name: "Dashboard",
            icon: "dashboard",
            component: Dash
        },

        {
            path: "graficos",
            name: "Gráficos",
            title: "Gráficos",
            icon: "bar_chart",
            component: FiltrarGrafico
        },
        {
            path: "auditoria",
            name: "Auditoria Técnica",
            icon: "image",
            component: InspecaoList
        },
        {
            path: "visita",
            name: "Visita Técnica",
            icon: "image",
            component: RelatorioList
        },

        {
            path: "validade",
            name: "Validade Produtos",
            icon: "image",
            component: ListProdValidade
        },

        {
            path: "documentos",
            name: "Documentação do Cliente",
            icon: "image",
            component: ListDocumentos
        },

        {
            path: "modelos",
            name: "Modelos de CheckList",
            icon: "image",
            component: ModeloCheckList
        },
        {
            path: "categorias",
            name: "Categorias",
            icon: "image",
            component: CategoriaList
        },
        {
            path: "itens",
            name: "Itens de CheckList",
            title: "Itens de Checklist",
            icon: "image",
            component: ItensCategoriaList
        },
        {
            path: "configuracao",
            name: "Configuração do Usuário",
            title: "Configuração do Usuário",
            icon: "image",
            component: Configuracao
        },

    ]
};

export default operacionalRoutes;